/*
 * AppCaller
 *
 * - Descrição
 *
 *  Oferece um loop que dispara eventos baseados em dois níveis a serem configurados
 *  nos arquivos de ambiente (ex: .env.development).
 *
 *  Existe a possibilidade do disparo do evento ser de forma forçada,
 *  invocando o método "appCallerDispatchEventByLevel". Quando esse método for chamado,
 *  o timer será resetado, ou seja: supondo que esse nível seja disparado a cada 10 segundos
 *  e, 2 segundos depois do disparo um novo disparo seja forçado, o proximo disparo
 *  somente acontecerá depois de 10 segundos (e não de 8).
 * *
 * - Configuração do ambiente
 *
 *      - Localização
 *          Aquivo de variáveis de ambiente, ex: ".env.development"
 *
 *      - Variável
 *          VUE_APP_CALLER_LEVELS
 *
 *      - Estrutura
 *          [{"level":1, "interval": <INTERVALO_SEGUNDOS>}, {"level":2,"interval": <INTERVALO_SEGUNDOS>}]
 *
 *          -Obs: Não esquecer que deve ficar na mesma linha
 *
 *      - Exemplo
 *          VUE_APP_CALLER_LEVELS=[{"level":1, "interval": 10}, {"level":2,"interval": 20}]
 *
 * - Configuração global
 *
 *      No arquivo main.js, fica o objeto usado para referenciar os níveis
 *
 *      $updNowLevels = {
 *          "level1": 1,
 *          "level2": 2
 *      };
 *
 * - Instanciar
 * Ex:
 *   //1
 *   EventBus.$on("scrollTopOverDetect", () => {
 *       this.appCallerDispatchEventByLevel(this.$updNowLevels.level1);
 *   });
 *
 *   //2
 *   this.appCallerListenEventByLevel(this.$updNowLevels.level1, () => {
 *       this.loadList();
 *   });
 *
 * ATENÇÃO!!!
 * Não usar arrow functions
 * Caso o listener seja instanciado no carregamento,  deve ser evento "mounted" e
 * não no "created", já que o appCaller reseta o Evento do "EventBus" durante a
 * execução do "beforeDestroy" da pagina anterior, o que pode ocorrer depois do
 * created da página subsequente.
 *
 * Entendeu? Nem eu!
 */

import { EventBus } from "@/event-bus";
import { AuthTools } from "../services/AuthTools";

export var appCaller = {

    name: "appCaller",

    data() {
        this.appCallerTime = 60;
        this.appCallerLevelsList = [];
        this.appCallerConfigs = null;
        this.authTools = new AuthTools();
    },

    created() {
        this._appCallerLoadConfigs();
        this._appCallerInit();
        this._appCallerLoop();
    },

    beforeDestroy() {
        EventBus.$off(this.$updNowEvt);
        this._appCallerClose();
    },

    methods: {

        _appCallerLoadConfigs() {

            if (this.appCallerConfigs) {
                return;
            }

            this.appCallerConfigs = JSON.parse(process.env.VUE_APP_CALLER_LEVELS);
        },

        _appCallerInit() {
            this.appCallerConfigs.map(function (item) {
                this._appCallerRegister(item.level, item.interval);
            }.bind(this));
        },

        _appCallerItemExists(item) {
            for (let i in this.appCallerLevelsList) {
                if (parseInt(this.appCallerLevelsList[i].level) === parseInt(item.level)) {
                    return true;
                }
            }
            return false;
        },

        _appCallerRemove(level) {
            this.appCallerLevelsList = this.appCallerLevelsList.filter((item) => {
                return !(parseInt(item.level) === parseInt(level));
            });
        },

        _appCallerResetTime(level) {
            for (let i in this.appCallerLevelsList) {
                const currentLevel = parseInt(this.appCallerLevelsList[i].level);
                const findLevel = parseInt(level);

                if (isNaN(currentLevel) || isNaN(findLevel)) {
                    console.error("Nível inválido, verifique agora!!!");
                }

                if (currentLevel === findLevel) {
                    let secBefore = this.appCallerLevelsList[i].timeSec;
                    this.appCallerLevelsList[i].timeSec = this.appCallerLevelsList[i].intervalSec;
                }
            }
        },

        _appCallerRemoveAll() {
            this.appCallerLevelsList = [];
        },

        /*
         * Dispara o evento "this.$updNowEvt" a cada N segundos, esse tempo é
         * resetado caso o usuário force algum disparo.
         */
        _appCallerRegister(level, intervalSec = 60) {

            const item = {};
            item.level = parseInt(level);
            item.intervalSec = parseInt(intervalSec);
            item.timeSec = parseInt(intervalSec);

            if (!this._appCallerItemExists(item)) {
                this.appCallerLevelsList.push(item);
            } else {
                console.log("Existe: ", item.level);
            }

            this.appCallerDispatchEventByLevel(item.level);
        },

        _appCallerClose() {
            this.appCallerLevelsList = [];
        },

        _appCallerLoop() {

            if (window.updIntHandler) {
                clearInterval(window.updIntHandler);
            }

            window.updIntHandler = setInterval(function () {
                console.log("LEN: ", this.appCallerLevelsList.length);
                this.appCallerLevelsList.map(function (item) {
                    this._appCallerLoopItem(item);
                }.bind(this));
            }.bind(this), 1000);
        },

        _appCallerLoopItem(item) {

            item.timeSec--;

            if (item.timeSec > 0) {
                return;
            }
            item.timeSec = parseInt(item.intervalSec);
            this.appCallerDispatchEventByLevel(item.level);
        },

        //Público
        appCallerDispatchEventByLevel(level) {

            if (false === this.authTools.hasJwt()) {
                return;
            }

            EventBus.$emit(this.$updNowEvt, {level: level});
        },

        //Público
        appCallerListenEventByLevel(level, fn) {
            if (level != 1 && level != 2) {
                alert("Nível inválido");
            }

            if (!this.$updNowEvt) {
                alert("Evento inválido");
            }

            EventBus.$on(this.$updNowEvt, function (data) {
                if (parseInt(data.level) === parseInt(level)) {
                    this._appCallerResetTime(data.level);//teste avaliar remoção
                    fn();
                }
            }.bind(this));

            if (false === this.authTools.hasJwt()) {
                return;
            }

            fn();
        }
    }
};